// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__2zfe9","errorLogs":"styles_errorLogs__1TNfI"};